
const INITIAL_STATE = {
  error: null,
  loading: null,
  data: [],
};

const deleteMedias = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "MEDIAS_DELETE_REQUEST":
      return { loading: true, error: false, data: [] };
    case "MEDIAS_DELETE_ERROR":
      return { loading: false, error: true, data: [] };
    case "MEDIAS_DELETE_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    default:
      return state;
  }
};

export default deleteMedias;
